require('./cmErrorState.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ components
const CmValidationSummary = require('../cmValidationSummary/cmValidationSummary');
const CmWizardSuccess = require('../cmWizardSuccess/cmWizardSuccess');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { EmptyState } = require('commonsComponents/emptyState');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @constants
const {
    CM_WIZARD_FIRST_STEP,
    CM_WIZARD_SECOND_STEP,
    CM_WIZARD_THIRD_STEP,
    CM_OPERATION_TYPE_TRASPASS,
    CM_BUY_TYPE_MONEY,
    CM_BROKER_PG_URL,
} = require('../../constants/constants');

class CmErrorState extends React.Component {
    constructor(props) {
        super(props);
        this.handleGetSimulationUrl = this.handleGetSimulationUrl.bind(this);
    }

    buildHeader(text) {
        return (
            <header className="cm-model-wallet-error__header-transfer">
                <span className="cm-model-wallet-error__info-body">
                    {formatText(text)}
                </span>
            </header>
        );
    }

    buildFundsSummary(portfolio) {
        const { immCmWalletBuy, onLegalDocumentClick } = this.props;
        const minAmounts = immCmWalletBuy.get('minAmounts');
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);

        return (
            <div className="cm-model-wallet-error__successful-div">
                <h2 className="cm-model-wallet-error__subtitle">
                    <FormattedText value="brokerCM-walletBuySuccessOrdersError" />
                </h2>
                <div className="cm-model-wallet-error__subtitle-text">
                    <FormattedText value="brokerCM-brokerCM_fundsInfoOrdersError" />
                </div>
                <CmValidationSummary
                    portfolio={portfolio}
                    showBuyButton={true}
                    hideTotal={true}
                    isTransferWithMoney={isTransferWithMoney}
                    onLegalDocumentClick={onLegalDocumentClick}
                    hasFundProductLink={true}
                    minAmounts={minAmounts}
                    hideDocument={true}
                />
            </div>
        );
    }

    buildEmptyState() {
        const primaryText = (
            <div className="cm-model-wallet-error__empty-state-text">
                <div>{formatText('brokerCM-brokerCM_validationError')}</div>
                <div>
                    {formatText('brokerCM-brokerCM_validationErrorSecondText')}
                </div>
            </div>
        );

        return (
            <ContentBox
                hasShadow={false}
                customClassName="cm-model-wallet-error__empty-state"
            >
                <EmptyState
                    secondaryText={primaryText}
                    iconType="noitems-wealth"
                    withMargin={false}
                />
            </ContentBox>
        );
    }

    handleGetSimulationUrl() {
        const { immCmWalletBuy } = this.props;
        const publicSiteUrl = getPublicSiteUrl(false);
        const simulationUrl = `${publicSiteUrl}/${immCmWalletBuy.getIn([
            'simulation',
            'returnPath',
        ])}`;
        window.location = simulationUrl;
    }

    render() {
        const { immCmWalletBuy } = this.props;
        const type = immCmWalletBuy.get('buyType');
        const errorValidation = immCmWalletBuy.get('errorValidation');
        const mainButtonLabel = formatText('brokerCM-brokerCM_walletButton');
        const investmentButtonLabel = formatText(
            'brokerCM-brokerCM_investmentButton',
        );
        const errorText = errorValidation
            ? 'brokerCM-brokerCM_walletBuyErrorValidationHeaderMessage'
            : 'brokerCM-brokerCM_walletBuyErrorConfirmationHeaderMessage';
        const headerBlock = this.buildHeader(errorText);
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);

        let validOrderResultOutputNoK = [];

        if (isTransferWithMoney) {
            const validatedOriginFundInfo = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_SECOND_STEP,
                'originFund',
            ]);
            const destFundsTransferCalculatorOutputList = validatedOriginFundInfo.getIn(
                [
                    'destFundsTransferCalculatorOutput',
                    'destFundTransferCalculatorList',
                ],
            );
            const destFundsTransferCalculatorOutputListFilter = destFundsTransferCalculatorOutputList.filter(
                destFund =>
                    !destFund
                        .get('operationType')
                        .startsWith(CM_OPERATION_TYPE_TRASPASS),
            );
            const transferOrderResultKoOutput = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_THIRD_STEP,
                'confirmFundsFromFundsWithMoneyData',
                'portfolioTransferConfirmationOutput',
                'transferOrderResultKoOutput',
            ]);
            validOrderResultOutputNoK = isTransferWithMoney
                ? destFundsTransferCalculatorOutputListFilter.concat(
                      transferOrderResultKoOutput,
                  )
                : [];
        }

        let content;

        if (errorValidation) {
            content = this.buildEmptyState();
        } else {
            const liquidtyTransfer = type === CM_BUY_TYPE_MONEY;
            let notSuccessful;

            if (liquidtyTransfer) {
                notSuccessful = immCmWalletBuy
                    .getIn(['orderValidation', 'validOrderResultOutputNoK'])
                    .concat(
                        immCmWalletBuy.getIn([
                            'orderConfirmationNotSuccessful',
                        ]),
                    );
            } else {
                notSuccessful = immCmWalletBuy
                    .getIn([
                        'orderValidation',
                        'portfolioOrderValidTransferNok',
                    ])
                    .concat(
                        immCmWalletBuy.getIn([
                            'orderConfirmationNotSuccessful',
                        ]),
                    );
            }

            notSuccessful = isTransferWithMoney
                ? notSuccessful.concat(validOrderResultOutputNoK)
                : notSuccessful;

            const fundsSummary = this.buildFundsSummary(notSuccessful);

            content = (
                <ContentBox hasShadow={false}>
                    <div className="cm-model-wallet-error__center-panel row">
                        <div className="col-lg-12">{fundsSummary}</div>
                    </div>
                </ContentBox>
            );
        }

        return (
            <div className="cm-model-wallet-error">
                {headerBlock}
                <CmWizardSuccess
                    successMessage=""
                    successSubMessage=""
                    customClassName="cm-model-wallet-error"
                    mainButton={{
                        label: investmentButtonLabel,
                        modifier: 'secondary',
                    }}
                    onMainButtonClick={this.handleGetSimulationUrl}
                    secondaryButton={{
                        label: mainButtonLabel,
                        url: CM_BROKER_PG_URL,
                    }}
                    secondaryButtonStyle="ghost"
                >
                    {content}
                </CmWizardSuccess>
            </div>
        );
    }
}

CmErrorState.propTypes = {
    immCmWalletBuy: PropTypes.object.isRequired,
    immCmLegalDocuments: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    onLegalDocumentClick: PropTypes.func,
};

module.exports = CmErrorState;
